import { yen } from '@/lib/price'
import { Order } from '~/api-client/data-contracts'

// 定期便の主商品はカテゴリごとに明細のラベルが異なるため、呼び出し側から指定する
type PrimaryItem = {
  match: string
  label: string
}

type Props = {
  order: Order | null
  primaryItem?: PrimaryItem
}

type DisplayItem = {
  label: string
  amount: number
  role?: string
}

function buildDisplayItems(order: Order, primaryItem: PrimaryItem): DisplayItem[] {
  const result: DisplayItem[] = []
  const items = order.attributes.display_items

  const subscriptionItem = items.find((item) => item.label.includes(primaryItem.match))
  subscriptionItem && result.push({ ...subscriptionItem, label: primaryItem.label })

  const vaseItem = items.find((item) => item.label.includes('花器'))
  vaseItem && result.push({ ...vaseItem, label: 'フラワーベース', amount: vaseItem.amount - order.attributes.product_discount })

  const deliveryFeeItem = items.find((item) => item.label.includes('クール便追加料金'))
  if (deliveryFeeItem) {
    result.push({ ...deliveryFeeItem, label: 'クール便追加料金' })
  } else {
    result.push({ label: '送料', amount: 0, role: 'default' })
  }

  const taxItem = items.find((item) => item.label.includes('消費税'))
  taxItem && result.push({ ...taxItem, label: '消費税（10%）' })

  return result
}

export const PriceTable: React.FC<Props> = ({ order, primaryItem = { match: 'グリーン', label: '季節の枝もの定期便（月1回）' } }) => {
  if (!order) return null

  const displayItems = buildDisplayItems(order, primaryItem)

  return (
    <div className="space-y-3 text-[14px]">
      {displayItems.map((item, index) => (
        <div key={index} className="flex justify-between">
          <span className="text-dark-gray">{item.label}</span>
          <span className="text-main">{item.amount === 0 ? '無料' : yen(item.amount)}</span>
        </div>
      ))}
      <div className="flex justify-between pt-4 border-t border-gray/40 font-medium">
        <span className="text-black">合計（税込）</span>
        <span className="text-[18px] text-black">{yen(order.attributes.total)}</span>
      </div>
    </div>
  )
}
